import React, { useEffect, useRef, useState } from "react";
import { MdOutlineDashboard } from "react-icons/md";
import styles from "../../PagesStyles/Heading.module.css"
import {
  AiOutlineDown,
  AiOutlineAppstore,
  AiOutlineGold,
} from "react-icons/ai";

import { NavLink, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function AdminSecondNavbar() {
  const navigate = useNavigate();
  const reports = [
    { id: 24, name: "Stock", linkto: "/stock_report" },
    { id: 25, name: "Sale", linkto: "/admin_sale_report" },
    { id: 25, name: "Order List", linkto: "/admin_orders" },
    { id: 26, name: "Purchase", linkto: "/purchase" },
    { id: 27, name: "Customer Ledger", linkto: "/ledger_main" },
    { id: 27, name: "Supplier Ledger", linkto: "/ledger_main" },
    { id: 29, name: "Old Metal", linkto: "/purchase?openView:RDPurchase" },
    { id: 28, name: "Cash", linkto: "/cash_report" },
    // { id: 30, name: "GST", linkto: "/adminhome" },
  ];

  return (
    <div className={styles.adminDesktopSecondNavbarMainBox} style={{zIndex:"10"}}>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
        <Icon className={styles.TabICon} width="24px" icon="ph:bag" />
        <NavLink to="/purchase_entry_new" className={styles["submenu-name"]}>
          Purchase Entry
        </NavLink>
 
      </div>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
        <Icon className={styles.TabICon} width="24px" icon="ic:outline-plus" />
        <NavLink to="/add_bulk_stock_new" className={styles["submenu-name"]}>
          Add Stock
        </NavLink>
 
      </div>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
        <Icon className={styles.TabICon} width="24px" icon="f7:cart" />
        <NavLink style={{textDecoration: 'none', color: 'black'}}  to="/admin_wholesale" className="submenu-name">
          Wholesale
        </NavLink>
 
      </div>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
        <Icon className={styles.TabICon} width="24px" icon="basil:invoice-outline" />
        {/* /admin_invoice */}
        <NavLink style={{textDecoration: 'none', color: 'black'}} to="/invoice_entry_new" className="submenu-name">  
          Invoices
        </NavLink>
 
      </div>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
      <Icon className={styles.TabICon} width="24px"  icon="tabler:transaction-rupee" />
        <NavLink style={{textDecoration: 'none', color: 'black'}}  to="/purchase_entry" className="submenu-name">
          Vendor Transaction
        </NavLink>
 
      </div>
      <div className={styles.adminDesktopSecondNavbarItemsBox}>
        <Icon className={styles.TabICon} width="24px" icon="fluent:people-money-20-regular" />
        <NavLink style={{textDecoration: 'none', color: 'black'}}  to="/purchase_entry" className="submenu-name">
        Customer Transaction
        </NavLink>
 
      </div>

    </div>
  );
}
